<rt-icons-container></rt-icons-container>
<div class="webapp-mock" layout-vertical>
  <div class="header" layout layout-space-between layout-align-items-center>
    <div class="search"></div>
    <div class="company"></div>
    <div class="avatar"></div>
  </div>
  <div layout layout-flex-1-1 style="min-height: 100%">
    <div class="sidebar"></div>
    <div class="content">
      <rt-spinner *ngIf="loading"></rt-spinner>
      <rtc-detached-router-outlet></rtc-detached-router-outlet>
    </div>
  </div>
</div>
